export default __webpack_public_path__ + "static/media/alkosto.43bad776.png";